export const loginUrl = "https://api-linkr-sql-9ai1.onrender.com/login";

export const logoutUrl = "https://api-linkr-sql-9ai1.onrender.com/logout";

export const signUpUrl = "https://api-linkr-sql-9ai1.onrender.com/signup";

export const trendingUrl = "https://api-linkr-sql-9ai1.onrender.com/trending";

export const usersLikedUrl = "https://api-linkr-sql-9ai1.onrender.com/posts/likes";

export const timelineUpdateUrl = "process.env.REACT_APP_API_BASE_URL/timelineUpdate";

export const editPostUrl = "https://api-linkr-sql-9ai1.onrender.com/posts";